(function () {
  const CARD_SELECTOR = '.product-grid__card';
  const PRICE_SELECTOR = '.price, .price-item__group, product-price';
  const DUPLICATE_AMOUNT = /(Rs\.?\s*[\d,]+(?:\.\d{2})?)(?:\s*\1)+/gi;

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function cleanCard(card) {
    // First remove an amount repeated inside the same price text node.
    const walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      if (!node.parentElement || !node.parentElement.closest(PRICE_SELECTOR)) return;
      const original = node.nodeValue || '';
      DUPLICATE_AMOUNT.lastIndex = 0;
      const cleaned = original.replace(DUPLICATE_AMOUNT, '$1');
      DUPLICATE_AMOUNT.lastIndex = 0;
      if (cleaned !== original) node.nodeValue = cleaned;
    });

    // Then remove a second price element only when its complete displayed value
    // exactly matches a value already shown in this product card.
    const seen = new Set();
    card.querySelectorAll('.price, .price-item__group').forEach((el) => {
      const value = normalize(el.textContent);
      if (!value) return;
      if (seen.has(value)) {
        el.remove();
      } else {
        seen.add(value);
      }
    });
  }

  function clean(root) {
    const cards = [];
    if (root instanceof Element && root.matches(CARD_SELECTOR)) cards.push(root);
    if (root.querySelectorAll) cards.push(...root.querySelectorAll(CARD_SELECTOR));
    cards.forEach(cleanCard);
  }

  function start() {
    clean(document);
    if (!document.body || window.__veranoirPriceDedupeObserver) return;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) clean(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__veranoirPriceDedupeObserver = observer;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();